import {
  CustomerActivity,
  CustomerActivityAction,
  CustomerActivityData,
} from "./types";
import { CustomerAddActivityPopup } from "./customer-add-activity";
import { CustomerDeleteActivityPopup } from "./customer-delete-activity";
import { CustomerEditActivityPopup } from "./customer-edit-activity";
import Container, { EmptyContainer } from "../../meta-container";
import { ActivityPopupMeta } from "../types";
import { BackContainer } from "../../../types";

const CustomerActivityPopupRenderer = <T extends {}>(
  props: ActivityPopupMeta<T>
) => {
  const activity = props.data as CustomerActivity;
  return (
    <Container<CustomerActivityAction, BackContainer<CustomerActivityData, T>>
      data={{ data: activity.data, back: props.back }}
      type={activity.action}
      match={{
        [CustomerActivityAction.None]: EmptyContainer,
        [CustomerActivityAction.Add]: CustomerAddActivityPopup,
        [CustomerActivityAction.Delete]: CustomerDeleteActivityPopup,
        [CustomerActivityAction.Edit]: CustomerEditActivityPopup,
      }}
    />
  );
};

export default CustomerActivityPopupRenderer;
